export const appsPortalDataNames = {
// add fields here
};
export const libsUiDataNames = {
    // add data names for lib ui here
    cardEditable: {
        dataName: 'cardEditable',
        switch: 'show-hide-switch',
        buttonDelete: 'buttonDelete',
        butonCustomDelete: 'butonCustomDelete',
        buttonEdit: 'buttonEdit',
        buttonAdd: 'buttonAdd',
    },
    shortcutKeyLegend: {
        button: 'buttonShortcut',
    },
    chip: {
        iconDelete: 'iconDelete',
    },
};
export const appsVSGADataNames = {
    damageDocumentation: {
        damageDescription: 'damageDescription',
        damageArea: 'damageArea',
        damageType: 'damageType',
        damageOverviewArrowButton: 'damage-overview-arrow-button',
        stepDamageInput: 'step-damage-input',
        stepPhotoInput: 'step-photo-input',
    },
    licensePlate: 'license-plate',
    vinNumber: 'vinNumber',
};
export const appsNmpDataNames = {
    dataCheck: {
        dialog: 'dataCheckDialog',
    },
    // add data names for nmp here
    // first level are the pages
    licensePlate: {
        cardEditable: {
            questionnaire: 'cardEditableQuestionnaire',
        },
    },
    vehicles: {
        // cards
        cardEditable: {
            vehicleType: 'vehicleType',
            seats: 'seats',
            engineType: 'engineType',
            performanceKW: 'performanceKW',
            maxTotalWeight: 'maxTotalWeight',
            baseVehicle: 'baseVehicle',
            wmpVehicleType: 'wmpVehicleType',
            constructionYear: 'constructionYear',
            modelgroupcode: 'modelgroupcode',
            manufacturernatcode: 'manufacturernatcode',
            buttonSaveVehicle: 'buttonSaveVehicle',
            exceptionOtherVehicles: 'exceptionOtherVehicles',
            vehicleListPrice: 'vehicleListPrice',
            nationalCode: 'nationalCode',
            euroTaxChips: {
                productionYear: 'productionYearChip',
                manufacturerNatCode: 'manufacturerNatCodeChip',
                modelGroupCode: 'modelGroupCodeChip',
                fuelType: 'fuelTypeChip',
                kiloWatt: 'kiloWattChip',
            },
        },
        otherRelevantData: {
            district: 'district',
            bonusMalusLevel: 'bonusMalusLevel',
        },
        datePicker: {
            initialRegistrationDate: 'initialRegistrationDate',
        },
    },
    coverage: {
        liability: {
            bonusAdvantage: 'bonusAdvantage',
        },
        bonusOptions: {
            bonusGiftsSelect: 'bonusGiftsSelect',
        },
        cardEditableSwitch: {
            liabilityCoverage: 'liabilityCoverage',
            passengerCoverage: 'passengerCoverage',
            cascoCoverage: 'cascoCoverage',
            bonusGifts: 'bonusGifts',
        },
        productOptions: {
            alternativeEngine: 'alternativeEngine',
        },
    },
    advisoryData: {
        placeOfTalk: 'placeOfTalk',
        reasonForTalk: 'reasonForTalk',
        lengthOfTalk: 'lengthOfTalk',
    },
    requestpolicydata: {
        bonusMalusData: {
            pendingClaims: {
                addPendingClaimsButton: 'addPendingClaimsButton',
            },
            bonusMalusUploadConfirmation: {
                card: 'bonusMalusUploadConfirmationCard',
            },
        },
        additinalVehicleData: {
            card: 'additinalVehicleDataCard',
        },
        paymentWay: {
            card: 'paymentWayCard',
        },
        differentAddress: {
            card: 'differentAddressCard',
            dialog: {
                searchDialog: {
                    name: 'searchAddressDialog',
                    selectAddress: 'searchAddressDialog.selectAddress',
                },
            },
        },
        applicationType: {
            applicationType: 'applicationType',
            applicationOne: 'applicationOne',
            applicationTwo: 'applicationTwo',
        },
        requestDuration: {
            allStartDates: 'allStartDates',
            liabilityStartDate: 'liabilityStartDate',
            passengerStartDate: 'passengerStartDate',
            comprehensiveStartDate: 'comprehensiveStartDate',
            liabilityEndDate: 'liabilityEndDate',
            passengerEndDate: 'passengerEndDate',
            comprehensiveEndDate: 'comprehensiveEndDate',
            variantDateCheckbox: 'variantDateCheckbox',
        },
        complementaryPartnerData: {
            card: 'complementaryPartnerDataCard',
            legitimationCardNumber: 'legitimationCardNumber',
            legitimationCardValidFrom: 'legitimationCardValidFrom',
            legitimationCardValidUntil: 'legitimationCardValidUntil',
        },
        consentVsga: {
            card: 'consentVsgaCard',
        },
        vinkulierung: {
            accountNumber: 'accountNumber',
            address: 'address',
            vgl: 'vgl',
        },
    },
    termsandconditions: {
        attachDocument: {
            card: 'cardAttachDocument',
        },
    },
    sideBar: {
        paymentWay: {
            card: 'sideBarPaymentWayCard',
        },
        dataCheckDialog: {
            icons: {
                warning: 'warning',
                error: 'error',
            },
        },
    },
    success: {
        success: {
            card: 'successCard',
        },
    },
};
export const libTemplateDataNames = {
    requestPayment: {
        iban: 'requestPaymentIBAN',
        bic: 'requestPaymentBIC',
        buttonAddBankAccount: 'buttonAddBankAccount',
        dialogIban: 'dataIbankDialog',
    },
    termsandconditions: {
        card: 'consentCard',
        legalAdviceAndProductionInformation: 'legalAdviceAndProductionInformation',
        rightToWithdraw: 'rightToWithdraw',
        agreementToElectronicCommunication: 'agreementToElectronicCommunication',
        formOfDeclarationsAndAgreementsInWriting: 'FormOfDeclarationsAndAgreementsInWriting',
        agreementOfContact: 'agreementOfContact',
        confirmationOfAdvisor: 'confirmationOfAdvisor',
    },
};
